import React from 'react'
import ProdIOTSumOPRow from './ProdIOTSumOPRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import useRowSelector from "../../../../../library/hooks/selector/useRowSelector";
import { UiView, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOTSumOP = (props) => {
    const { formObject, viewData } = props;

    const rowSelector = useRowSelector("2", null);

    return (
        <>
            <UiView>
                <UiViewContent>
                    <ul className="uiListTable uiProductionTable uiRawDataView" style={{ minWidth: "1060px" }}>
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnLeft uiColumn130"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnLeft uiColumn350"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn100" headerKey="viewConfig"
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn100" headerKey="viewConfig"
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Returned" /></li>
                                <li className="uiColumnRight uiColumn70"><SarasTrans value="Unit Cost" /></li>
                                <li className="uiColumnLeft uiColumn100"><SarasTrans value="Remark" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Type" /> </li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li>
                                    <ProdIOTSumOPRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} index={index + 1} />
                                </li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOTSumOP, "prodIOTSumOP", "");
